//components
import React, { useEffect, useState } from 'react';
import CustomModal from '../../components/modal';
import ImageGallery from '../../components/imageGallery';
import { themePropType } from '../../components/sharedPropTypes';
import { getImagePaths, loadImages } from '../../utils/imageLoader';

const VirtualPetPage = ({ theme }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [petImages, setPetImages] = useState([]);
  
  //For dynamic imports (better for code splitting)
  useEffect(() => {
      const loadCollectionImages = async () => {
      const images = await loadImages('virtualPets');
      setPetImages(images);
      };
      loadCollectionImages();
  }, []);
  
  return (
    <div className='virtualPetsPage'>
      <h3>Virtual Pets</h3>
      <ImageGallery 
        images={petImages}
        onImageClick={setSelectedImage}
      />
      <CustomModal
        isOpen={!!selectedImage}
        onRequestClose={() => setSelectedImage(null)}
        theme={theme}
      >
        {selectedImage && (
          <img 
            src={selectedImage} 
            style={{ maxWidth: '100%', maxHeight: '80vh' }} 
            alt="Enlarged pet" 
          />
        )}
      </CustomModal>
    </div>
  );
};

VirtualPetPage.propTypes = {
  theme: themePropType
};
export default VirtualPetPage;